import * as React from 'react';
import styled from '@emotion/styled';
import {
    CheckmarkList,
    CheckmarkListItem,
    CheckmarkListItemIcon,
    CheckmarkListItemText,
} from '../../../components/CheckmarkList/CheckmarkList';
import { getDepartureDate } from '../../../helpers/cruisePageHelpers';
import { __ } from '../../../helpers/TranslationService';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        fontSize: 14,
    },
    row: {
        display: 'flex',
        marginBottom: 10,
    },
    leftColumn: {
        flex: '0 0 auto',
        width: '45%',
    },
    rightColumn: {
        paddingLeft: 10,
        width: '55%',
        flex: '0 0 auto',
    },
    inclusives: {
        marginBottom: 5,
        lineHeight: '20px',
        display: 'flex',
    },
};

const CruiseOverviewWrapper = styled.div`
    font-size: 14px;
`;

const CruiseOverviewContent = styled.div`
    margin-bottom: 36px;
`;

const CruiseOverviewSubtitle = styled.b`
    display: block;
    margin-bottom: 16px;
`;
interface IRowProps {
    title: string;
    children?: JSX.Element[] | number | string;
}
function Row({ title, children }: IRowProps) {
    return (
        <div style={styles.row}>
            <div style={styles.leftColumn}>{`${__(title, 'dreamlines')}:`}</div>
            <div style={styles.rightColumn}>{children}</div>
        </div>
    );
}
interface IProps {
    startHarbour: string;
    endHarbour: string;
}

export function CruiseOverview(props: IProps) {
    const { startHarbour, endHarbour } = props;
    const { cruisePage } = useTypedSelector((state) => state);
    const { zone, nights, sails, dateRange, company, ship, nid, icons, tvOfferCode } = cruisePage;
    const departureDates = getDepartureDate({ sails, dateRange });
    const getInclusives = () =>
        icons.map((icon) => {
            return icon ? (
                <CheckmarkListItem key={icon.text}>
                    <CheckmarkListItemIcon />
                    <CheckmarkListItemText>{__(icon.text, 'dreamlines')}</CheckmarkListItemText>
                </CheckmarkListItem>
            ) : null;
        });
    return (
        <CruiseOverviewWrapper>
            <CruiseOverviewSubtitle>{__('Cruise details', 'dreamlines')}:</CruiseOverviewSubtitle>
            <CruiseOverviewContent>
                <Row title="Company">{company.title}</Row>
                <Row title="ship">{ship.title}</Row>
                <Row title="Destination">{zone}</Row>
                <Row title="Startharbour">{startHarbour}</Row>
                <Row title="Endharbour">{endHarbour}</Row>
                <Row title="Duration">{`${nights} ${__('nights', 'dreamlines')}`}</Row>
                <Row title="Dates">{departureDates}</Row>
                <Row title="Cruise Nr.">{nid}</Row>
                {tvOfferCode && <Row title="tvOfferCode">{tvOfferCode}</Row>}
            </CruiseOverviewContent>
            <CruiseOverviewSubtitle>
                {__('included services', 'dreamlines')}:
            </CruiseOverviewSubtitle>
            <CheckmarkList>{getInclusives()}</CheckmarkList>
        </CruiseOverviewWrapper>
    );
}
